<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
    </div>
    <!-- 检索 -->
    <div
      class="backwhite border-rd3 flexleft"
      style="min-height: 120px"
      v-if="serchkey"
    >
      <el-form
        ref="ruleForm"
        size="small"
        label-width="100px"
        class="demo-ruleForm width90 flexleft"
      >
        <el-form-item label="合同名称">
          <el-input placeholder="请输入合同名称" v-model="input"></el-input>
        </el-form-item>
        <el-form-item label="签署时间">
          <el-date-picker
            v-model="number"
            :editable="false"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合作方名称">
          <el-input placeholder="请输入合作方名称" v-model="inputs"></el-input>
        </el-form-item>
      </el-form>
      <div class="width96 margin-auto flex-betweennowrap pad-bot10">
        <p>
          <el-button type="primary" @click="submitForm()">检 索</el-button>
          <el-button @click="resetForm()" class="resetbtn">重 置</el-button>
        </p>
        <span class="attention f14" @click="toproductaddfication()">新 增</span>
      </div>
    </div>

    <el-skeleton
      class="width100 backwhite border-rd3"
      :loading="true"
      animated
      :throttle="500"
    >
      <template slot="template">
        <div
          class="
            width100
            backwhite
            pad-bot20 pad-top20
            margin-auto margin-top15
            border-rd3
            alldigital
          "
          v-if="total != 0"
        >
          <el-table
            :data="page"
            stripe
            style="width: 98%"
            class="eltable margin-auto f14"
          >
            <el-table-column label="合同名称" align="left" min-width="150%"
              ><template slot-scope="scope">
                <span
                  @click="detailen(scope.row)"
                  class="bluecolor cursorpointer"
                  >{{ scope.row.title }}</span
                ></template
              ></el-table-column
            >
            <el-table-column label="合同金额" align="center">
              <template slot-scope="scope">
                {{ scope.row.amount }} 万
              </template>
            </el-table-column>
            <el-table-column
              label="签署日期"
              align="center"
              prop="write_date"
            />
            <el-table-column label="合作方名称" align="center" prop="parter" />
            <el-table-column
              label="操作"
              align="center"
              class-name="small-padding fixed-width"
            >
              <template slot-scope="scope">
                <span
                  class="bluecolor cursorpointer"
                  @click="detailen(scope.row)"
                  >详情</span
                >
                <span
                  class="bluecolor cursorpointer margin-left10"
                  @click="todetails(scope.row)"
                  >修改</span
                >
                <span
                  class="bluecolor cursorpointer margin-left10"
                  @click="removepro(scope.row)"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div
            class="flex-betweennowrap pad-top20 pad-right10"
            v-if="total != 0"
          >
            <span class="bluecolor"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
        <div
          class="width100 margin-auto backgroudFFF margin-top15"
          v-if="total == 0"
        >
          <el-empty
            :image="require('@/assets/barsvg/zwsj@3x.png')"
            :image-size="200"
            description="抱歉，没有搜到您想要的内容"
            class="heightempty"
            ><p style="position: relative; bottom: 60px" class="f14">
              暂无数据
            </p></el-empty
          >
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleadd"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <Enterpriseaddfication></Enterpriseaddfication>
    </el-dialog>
    <!-- 修改 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisiblemodify"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class="errorboxs"
    >
      <Enterprisemodification></Enterprisemodification>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibledetily"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="30%"
      class=""
    >
      <Enterprisedetail></Enterprisedetail>
    </el-dialog>
  </div>
</template>
 <script>
import { entcontractindex, entcontractdelete } from "@/api/Center/Center.api";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
import callback from "@/components/callback.vue";
import Enterpriseaddfication from "./Enterprise-addfication.vue";
import Enterprisemodification from "./Enterprise-modification.vue";
import Enterprisedetail from "./Enterprise-detail.vue";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibleadd: false,
      dialogVisiblemodify: false,
      dialogVisibledetily: false,
      pagination: false,
      serchkey: true,
      ruleForm: {
        pipo: "",
        name: "",
      },
      thisNum: 1,
      page: [],
      total: 0,
      per_page: 0,
      currentPage: 1,
      input: "",
      inputs: "",
      number: "",
    };
  },
  components: {
    callback,
    switchcore,
    Enterpriseaddfication,
    Enterprisemodification,
    Enterprisedetail,
  },
  methods: {
    //   产品添加
    toproductaddfication() {
      this.dialogVisibleadd = true;
    },
    // 删除
    removepro(row) {
      this.$confirm("此操作将删除此合同, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          entcontractdelete({ id: row.id }).then((res) => {
            if (res.data.code == 200) {
              this.refresh();
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 修改
    todetails(row) {
      window.sessionStorage.setItem("Enterprisemodification", row.id);
      BUS.$emit("Enterprisemodification", row.id);
      this.dialogVisiblemodify = true;
    },
    // 详情
    detailen(row) {
      window.sessionStorage.setItem("Enterprisemodification", row.id);
      BUS.$emit("Enterprisemodification", row.id);
      this.dialogVisibledetily = true;
    },
    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      entcontractindex({
        page: val,
        _keywords: this.input,
        tech_keyword: this.inputs,
        start_date: this.number[0] + " " + "-" + " " + this.number[1],
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      entcontractindex({
        page: 1,
        limit: val,
        _keywords: this.input,
        tech_keyword: this.inputs,
        start_date: this.number[0] + " " + "-" + " " + this.number[1],
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    // input重 置
    resetForm() {
      this.input = null;
      this.inputs = null;
      this.number = null;
      this.thisNum = 1;
      entcontractindex({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    submitForm() {
      entcontractindex({
        _keywords: this.input,
        tech_keyword: this.inputs,
        start_date: this.number[0] + " " + "-" + " " + this.number[1],
        page: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      entcontractindex({
        page: this.thisNum,
        _keywords: this.input,
        tech_keyword: this.inputs,
        start_date: this.number[0] + " " + "-" + " " + this.number[1],
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    entcontractindex({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("enterpriseaddfication", (data) => {
      if (data == "yes") {
        this.dialogVisibleadd = false;
        this.dialogVisiblemodify = false;
        this.dialogVisibledetily = false;
        this.refresh();
      } else {
        this.dialogVisibleadd = false;
        this.dialogVisiblemodify = false;
        this.dialogVisibledetily = false;
      }
    });
  },
};
</script>
<style scoped>
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.editor >>> .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>